import { createElement } from "../21946.js";

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var coupon_tag_SvgCouponTag = function SvgCouponTag(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M7.107 14.803c-.36 0-.723-.136-.998-.41L1.96 10.24a1.4 1.4 0 0 1-.413-.997c0-.376.146-.73.413-.998l5.915-5.912a1.35 1.35 0 0 1 1.005-.392l4.24.18a1.164 1.164 0 0 1 1.11 1.108l.178 4.24c.016.374-.128.742-.392 1.006l-5.912 5.914a1.4 1.4 0 0 1-.997.414Zm-.243-1.168a.344.344 0 0 0 .485 0l5.915-5.915a.28.28 0 0 0 .08-.205l-.179-4.24c-.002-.048-.04-.088-.088-.088l-4.24-.179a.3.3 0 0 0-.205.08L2.715 9.003a.34.34 0 0 0-.099.242.33.33 0 0 0 .101.243z"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M10.355 7.757a1.76 1.76 0 1 1-.001-3.52 1.76 1.76 0 0 1 0 3.52m0-2.456a.69.69 0 0 0-.642.428.69.69 0 0 0 .377.907.696.696 0 0 0 .758-1.135.72.72 0 0 0-.493-.2"
  })));
};
/* export default */ const coupon_tag = (coupon_tag_SvgCouponTag);
export default coupon_tag;
